import {readFragmentFromCache} from 'graphql-client/ApolloWrappers';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

import {AllTagSchemasGraphQL} from '../../../graphql-fragments/schemas/tag-schemas/__generated/AllTagSchemasGraphQL';

export function getAllListingTagSchemasFromCache(): AllTagSchemasGraphQL['tagSchemas'] {
  const cacheResult = readFragmentFromCache(getFragmentWrapper('AllTagSchemas'));
  return cacheResult ? cacheResult.tagSchemas : [];
}
